import styled from 'styled-components';

import * as Common from '../../../Styles';
import * as MUIIcon from '@mui/icons-material';

const Theme = Common.Theme;

export const AddFileIcon = styled(MUIIcon.Description)``;

export const ProcessingIcon = styled(MUIIcon.Sync)``;

export const SuccessIcon = styled(MUIIcon.CheckCircleOutline)``;

export const ArrowRightIcon = styled(MUIIcon.ArrowRight)``;

export const DatabaseIcon = styled(MUIIcon.Storage)``;

export const FailedIcon = styled(MUIIcon.SyncProblem)``;

export const ErrorIcon = styled(MUIIcon.ErrorOutline)``;
